import { LOCALES } from './locales-constants';

export default {
  [LOCALES.ENGLISH]: {
    operations: 'Operations',
    configuration: 'Configuration',
    zoning: 'Fare Products',
    welcome: 'Welcome',
    selectStatement: 'Select one of the below systems to proceed',
    login: 'Login',
    logout: 'Logout',
    eazyMobility: 'Eazy Mobility',
    routes: 'Routes',
    englishName: 'English Name',
    arabicName: 'Arabic Name',
    code: 'Code',
    groups: 'Groups',
    organization: 'Organization',
    customerSupport: "Customer Support",
    fareMediaInquery: "Fare Media Inquiry",
    actions: 'Actions',
    addRoute: 'Add Route',
    loginHint: 'Please login to access your account',
    userName: 'Username',
    password: 'Password',
    addOrganization: 'Add Organization',
    pageNotFound: 'Page Not Found',
    notExist: 'Sorry, the page youâ€™re looking for doesnâ€™t exist.',
    goToHome: 'Go To Home',
    status: 'Status',
    drivers: 'Drivers',
    admins: 'Admins',
    organizations: 'Organizations',
    delete: 'Delete',
    confirmDeleteMessage: 'Are you sure you would like to delete',
    AreYouSureDelete: 'Are you sure you want to delete this record?',
    route: 'Route',
    cancel: 'Cancel',
    enabled: 'Enabled',
    update: 'Update',
    edit: 'Edit',
    editRoute: 'Edit Route',
    createRoute: 'Create New Route',
    create: 'Create',
    routeInfo: 'Route Info',
    noGroups: 'No groups assigned to this route yet.',
    back: 'Back',
    saveGroups: 'Save Groups',
    createOrganization: 'Add Organization',
    editOrganization: 'Edit Organization',
    oranizationInfo: 'Organization Info',
    name: 'Name',
    lastLogin: 'Last Login',
    addAdmin: 'Add Admin',
    editAdmin: 'Edit Admin',
    email: 'Email',
    phone: 'Phone',
    firstName: 'First Name',
    lastName: 'Last Name',
    repeatPassword: 'Repeat Password',
    somethingWrong: 'Sorry, something went wrong!',
    mwaslatMasrSuperDASH: 'Mwasala.Tech Super Dash',
    adminInfo: 'Admin Info',
    masterConfiguration: 'Master Configuration',
    component: 'Component',
    permissionType: 'Permission Type',

    save: 'Save',
    operationsOrganizationLevel: 'Operations Organization Level',
    requiredValidation: 'This Field is required',
    passwordMatchValidation: 'Password must match',
    validEmailValidation: 'Please enter a valid email',
    addDriver: 'Add Driver',
    searchByName: 'Search by name',
    driverInfo: 'Driver Info',
    nationalId: 'National ID',
    licenseNumber: 'License Number',
    backToDriversList: 'Back To Drivers List',
    driver: 'Driver',
    import: 'Import',
    export: 'Export',
    successEditDriverMessage: 'You have successfully updated driver!',
    editDriver: 'Edit Driver',
    createDriver: 'Add Driver',
    organizationId: 'organization Id',
    show: 'Show:',
    jumpToPage: 'Jump to page',
    addToGroups: 'Add To Groups',
    clearGroups: 'Clear Groups',
    enable: 'Enable',
    disable: 'Disable',
    add: 'Add',
    reset: 'reset',
    filter: 'Filter',
    filters: 'Filters',
    group: 'Group',
    all: 'All',
    apply: 'Apply',
    disabled: 'Disabled',
    confirmenableMessage: 'Are you sure you want to enable selected',
    confirmdisableMessage: 'Are you sure you want to disable selected',
    confirmassignMessage: 'Are you sure you want to assign to groups selected',
    confirmclearGroupsMessage:
      'Are you sure you want to clear groups for selected',
    confirm: 'Confirm',
    noOrganization: 'No organizations found',
    selectAll: 'Select All',
    noGroupsFound: 'No groups found',
    successAddDriver: 'You have successfully added driver!',
    successAddRoute: 'You have successfully added route!',
    successAddOrganization: 'You have successfully added organization!',
    successAddAdmin: 'You have successfully added admin!',
    successEditDriver: 'You have successfully edited driver!',
    successEditRoute: 'You have successfully edited route!',
    successEditOrganization: 'You have successfully edited organization!',
    successEditAdmin: 'You have successfully edited admin!',
    nationalIdMaxValidationMsg: 'Must be maximum 15 digits',
    digitsOnly: 'Must be only digits',
    phoneMaxValidationMsg: 'Must be maximum 11 digits',
    editProfile: 'Edit Profile',
    changePassword: 'Change Password',
    editMyProfile: 'Edit My Profile',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    changePasswordRoles:
      'In order to protect your account, your password must have:',
    passwordCharacterLength: '6 or more characters',
    passwordValidationLetter: 'At least one letter',
    passwordValidationDigits: 'At least one number',
    successdeletedriver: 'The Driver has been deleted successfully',
    noResultYet: 'No Results yet',
    noResultNote: 'Once you add, youâ€™ll see them here.',
    addBtn: 'Add',
    backToOrganizationList: 'Back To Organization List',
    backToRoutesList: 'Back To Route List',
    regeneratePassword: 'Regenerate Password',
    successRegeneratedPassword: 'You have succesfully regenerated password!',
    clearAll: 'Clear All',
    restricted: 'Restricted',
    fares: 'Fares',
    discountTypes: 'Discount Types',
    AddDiscountType: 'Add Discount Type',
    AddNewDiscountType: 'Add New Discount Type',
    EditDiscountType: 'Edit Discount Type',
    DiscountTypeInfo: 'Discount Type Information',
    DiscountTypeCreatedSuccessfully: 'Discount Type Created Successfully',
    DiscountTypeUpdatedSuccessfully: 'Discount Type Updated Successfully',
    BackToDiscountTypes: 'Back to Discount Types',
    NameEnglish: 'Name (English)',
    NameArabic: 'Name (Arabic)',
    SearchDiscountTypePlaceholder: 'Search by code or name',
    AreYouSureDeleteDiscountType: 'Are you sure you want to delete this discount type?',
    PassengerCategories: 'Passenger Categories',
    AddPassengerCategory: 'Add Passenger Category',
    AddNewPassengerCategory: 'Add New Passenger Category',
    EditPassengerCategory: 'Edit Passenger Category',
    PassengerCategoryInfo: 'Passenger Category Information',
    PassengerCategoryCreatedSuccessfully: 'Passenger Category Created Successfully',
    PassengerCategoryUpdatedSuccessfully: 'Passenger Category Updated Successfully',
    SearchPassengerCategoryPlaceholder: 'Search by code or name',
    AreYouSureDeletePassengerCategory: 'Are you sure you want to delete this category?',
    PassengersGroups: 'Passengers Groups',
    AddPassengersGroup: 'Add Passengers Group',
    AddNewPassengersGroup: 'Add New Passengers Group',
    EditPassengersGroup: 'Edit Passengers Group',
    PassengersGroupInfo: 'Passengers Group Information',
    IsDefaultGroup: 'Set as Default Group (organisation fallback)',
    PassengersGroupCreatedSuccessfully: 'Passengers Group Created Successfully',
    PassengersGroupUpdatedSuccessfully: 'Passengers Group Updated Successfully',
    SearchPassengersGroupPlaceholder: 'Search by group name...',
    AreYouSureDeletePassengersGroup: 'Are you sure you want to delete this group?',
    GroupName: 'Group Name',
    Users: 'Users',
    UserInfo: 'User Info',
    Phone: 'Phone',
    Email: 'Email',
    points: 'Points',
    wallet_balance: 'Wallet Balance',
    LinkedFareMedia: 'Linked Fare Media',
    Relation: 'Type',
    Own: 'Own',
    Child: 'Child',
    SearchUserPlaceholder: 'Search by name, phone or email',
    ChangePassengerGroup: 'Change Passenger Group',
    UserGroupUpdated: 'User passenger group updated successfully',
    EligibilityDocuments: 'Eligibility Documents',
    AddEligibility: 'Add Eligibility Document',
    EligibilityAdded: 'Eligibility document added successfully',
    EligibilityUpdated: 'Eligibility document updated successfully',
    EligibilityDeleted: 'Eligibility document deleted successfully',
    FromGroup: 'From Group',
    ToGroup: 'To Group',
    ChangedBy: 'Changed By',
    ChangedAt: 'Changed At',
    FareMediaBatches: 'Fare Media Batches',
    AddFareMediaBatch: 'Add Fare Media Batch',
    AddNewFareMediaBatch: 'Add New Fare Media Batch',
    EditFareMediaBatch: 'Edit Fare Media Batch',
    FareMediaBatchInfo: 'Fare Media Batch Information',
    FareMediaBatchCreatedSuccessfully: 'Fare Media Batch Created Successfully',
    FareMediaBatchUpdatedSuccessfully: 'Fare Media Batch Updated Successfully',
    SearchFareMediaBatchPlaceholder: 'Search by label or note...',
    AreYouSureDeleteFareMediaBatch: 'Are you sure you want to delete this batch?',
    BatchLabel: 'Batch Label',
    Notes: 'Notes',
    CreatedBy: 'Created By',
    UpdatedBy: 'Updated By',
    FareMediaCount: 'Fare Media Count',
    IsDefault: 'Default Group',
    FareProductOptions: 'Fare Product Options',
    PurchasePrice: 'Purchase Price',
    ContractDurationDays: 'Contract Duration (Days)',
    MaxAmount: 'Max Spend Amount',
    MaxTrips: 'Max Trips',
    ConsumedTrips: 'Consumed Trips',
    ActivationTrigger: 'Activation Trigger',
    FirstUse: 'First Use',
    FIRST_USE: 'First Use',
    SpecificDate: 'Specific Date',
    SPECIFIC_DATE: 'Specific Date',
    IMMEDIATE: 'Immediate',
    // v5 legacy kept for backward compat
    PrepaidPassOptions: 'Fare Product Options',
    MaxUsageCount: 'Max Usage Count (Trips)',
    ValidityDaysAfterActivation: 'Contract Duration (Days)',
    PassName: 'Fare Product Name',
    PassCode: 'Fare Product Code',
    ConsumedAmount: 'Consumed Amount',
    ContractStart: 'Contract Start',
    ContractEnd: 'Contract End',
    PurchasedAt: 'Purchased At',
    ActivatedAt: 'Activated At',
    // kept for legacy table rendering
    TripsConsumed: 'Consumed Amount',
    ExpiresAt: 'Contract End',
    NoOffersFound: 'No fare product instances found for this fare media.',
    FareProductNoUserHint: "You can't use Buy Fare Product until the user adds this fare media in their app.",
    Offers: 'Fare Products',
    CancelFareProduct: 'Cancel Fare Product',
    CancelFareProductConfirm: 'Are you sure you want to cancel this fare product instance? This action cannot be undone.',
    CancellationReason: 'Cancellation Reason',
    PleaseSelectBandAndDate: 'Please select a discount band and from date.',
    CheckApplicableFares: "Check Applicable Fares",
    FailedToFetchApplicableFares: "Failed to fetch applicable fares.",
    AxisAndZones: "Axis / Zone",
    LowestChargeableFare: "Lowest chargeable fare",
    HighestChargeableFare: "Highest chargeable fare",
    NoBaseFareOnAxis: "No base fare configured on this axis",
    NoZonesOnAxis: "No zones on this axis — base fare applies throughout",
    UnattributedFares: "Prices not linked to any axis",
    DiscountExceedsFloor: "Discount exceeds the lowest chargeable fare on the selected routes",
    PriceBelowActiveDiscount: "This price is lower than an active fixed discount on this axis",
    MinimumAllowedPrice: "minimum allowed",
    CouldNotVerifyDiscountUsage: "Could not verify active discounts for this axis — saving without that check.",
    BaseFareLabel: "Base fare",
    EffectiveFare: "Effective fare",
    FareValidFrom: "from",
    Zone: "Zone",
    YourFixedDiscount: "Your fixed discount",
    VerdictOk: "Fits every fare listed below.",
    VerdictPartial: "Can be saved, but it does not fit every route.",
    VerdictBlockedBand: "Cannot save — this discount is larger than every fare in this organisation.",
    VerdictBlockedAssignment: "Cannot save — this discount is larger than the cheapest fare on the selected routes, so those trips would become free.",
    AxesCheaperThanDiscount: "Axes cheaper than your discount",
    CheapestIs: "cheapest is",
    AffectedHintBand: "Assigning this band to any of them will be rejected. They are highlighted below.",
    AffectedHintAssignment: "Remove those routes from this assignment, or lower the discount.",
    BelowDiscountMarker: "below discount",
    DiscountExceedsMaxFare: "Discount exceeds the highest active fare",
    DiscountBandFaresHint: "Every chargeable fare in this organisation — each axis base fare with its zone prices underneath. A fixed discount above the lowest one makes those trips free.",
    AssignmentFaresHint: "Every chargeable fare on the selected routes, base fares and zone prices together. The lowest value is the exact limit this save enforces.",
    Yes: 'Yes',
    No: 'No',
    DiscountBands: 'Discount Bands',
    AddNewDiscountBand: 'Add New Discount Band',
    EditDiscountBand: 'Edit Discount Band',
    ArName: 'Arabic Name',
    EnName: 'English Name',
    DiscountBandInfo: 'Discount Band Information',
    DiscountBandCreatedSuccessfully: 'Discount Band Created Successfully',
    DiscountBandUpdatedSuccessfully: 'Discount Band Updated Successfully',
    SearchDiscountBandPlaceholder: 'Search by code or name...',
    AreYouSureDeleteDiscountBand: 'Are you sure you want to delete this discount band?',
    DiscountValue: 'Discount / Offer Value',
    Percentage: 'Percentage',
    Amount: 'Amount',
    RequiresDocuments: 'Requires Documents',
    ValidFrom: 'Product Valid From',
    ValidTo: 'Product Valid To',
    AssignmentValidFrom: 'Assignment Valid From',
    AssignmentValidTo: 'Assignment Valid To',
    TimeFrom: 'Time From',
    TimeTo: 'Time To',
    AllDay: 'All Day',
    NoExpiry: 'No Expiry',
    AllDays: 'All Days',
    AvailableDays: 'Available Days',
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    DiscountPct: 'Discount %',
    DiscountAmount: 'Discount Amount',
    DiscountType: 'Discount Type',
    PassengerCategory: 'Passenger Category',
    BasicInfo: 'Basic Information',
    DiscountBand: 'Discount Band',
    PassengersGroup: 'Passengers Group',
    passengers_group: 'Passengers Group',
    DiscountCalculation: 'Discount / Offer Calculation Method',
    Validity: 'Validity Information',
    ApplyOnAllRoutes: 'Apply on all routes',
    IsActive: 'Is Active',
    passengers_group_name: 'Group Name',
    fare_media_batch_label: 'Batch Label',
    SelectOrgFirst: 'Select an organisation first',
    GroupChangeWarning: 'If the group changed, the eligibility needs to be added again, and old specific eligibility records will be removed.',
    group_change_reason: 'Group Change Reason',
    enter_reason: 'Please enter the reason for group change',
    Eligibility: 'Eligibility',
    GroupHistory: 'Group History',
    from_group_name: 'From Group',
    to_group_name: 'To Group',
    AssociatedDiscountBandAssignments: 'Associated Assignments',
    AssociatedDiscountBands: 'Associated Discount Bands',
    AssociatedFareMediaEligibility: 'Associated Fare Media Eligibility',
    AssociatedTickets: 'Associated Tickets',
    changed_at: 'Changed At',
    changed_by: 'Changed By',
    doc_type_code: 'Document Type',
    DocumentTypes: 'Document Types',
    DocumentType: 'Document Type',
    AddNewDocumentType: 'Add Document Type',
    EditDocumentType: 'Edit Document Type',
    DocumentTypeInfo: 'Document Type Info',
    SearchDocumentTypePlaceholder: 'Search Document Types...',
    AreYouSureDeleteDocumentType: 'Are you sure you want to delete this document type?',
    DocumentTypeCreatedSuccessfully: 'Document Type created successfully',
    DocumentTypeUpdatedSuccessfully: 'Document Type updated successfully',
    ValidationRules: 'Validation Rules',
    ValidationRulesOptional: 'Validation Rules (Optional)',
    ValidationRulesHint: 'Define rules that will be enforced on the Remarks field when adding eligibility records for this document type.',
    InputType: 'Input Type',
    NoRestriction: 'No Restriction',
    NumericOnly: 'Numbers Only',
    AlphaOnly: 'Letters Only',
    AlphanumericOnly: 'Letters & Numbers (both)',
    MinLength: 'Min Length',
    MaxLength: 'Max Length',
    AllowSpecialChars: 'Allow Special Characters',
    SpecialCharsAllowed: 'Allowed Special Characters',
    RemarksValidationRules: 'Remarks Validation Rules',
    ClearValidationRules: 'Clear Rules',
    ValidExampleShort: 'e.g.',
    DocumentIdentifier: 'Document Identifier',
    DocIdentifierShort: 'Doc. Identifier',
    EnterDocumentIdentifier: 'Enter document identifier',
    IdentifierValidationRules: 'Identifier Validation Rules',
    optional: 'Optional',
    AvailableDocumentTypes: 'Available Document Types',
    SelectedDocumentTypes: 'Selected Document Types',
    selected: 'selected',
    RequiresDocumentsValidation: 'Please select at least one document type when "Requires Documents" is enabled.',
    ActivationTriggerRequired: 'Activation Trigger is required when Contract Duration Days is set.',
    issued_at: 'Issued At',
    expires_at: 'Expires At',
    verified_by: 'Verified By',
    verified_at: 'Verified At',
    remarks: 'Remarks',
    financialControl: 'Financial Control',
    digitalSignage: 'Digital Signage',
    helpDesk: 'Help Desk',
    editAdminInfo: 'Edit Admin Info',
    resetPassword: 'Reset Password',
    theNewPasswordMustHave: 'The new password must have',
    sixOrMoreCharacters: '6 or more characters',
    atLeastOneLetter: 'at least one letter',
    atLeastOneNumber: 'at least one number',
    grantFullControl: 'Grant Full Control',
    denyAllAccess: 'Deny All Access',
    editPermissions: 'Edit Permissions',
    noAccess: 'No Access',
    fullAccess: 'Full Control',
    readOnly: 'Read Only',
    adminPermissions: 'Admin Permissions',
    admin: 'Admin',
    successUpdatePermissions: 'You have successfully updated permissions!',
    successGrantFullControl: 'You have successfully granted full control!',
    successDenyAllAccess: 'You have successfully denied all access!',
    superAdmin: 'Super Admin',
    axes: 'Axes',
    tripSales: 'Trip Sales',
    addTripSale: 'Add Trip Sale',
    ticketSerial: 'Ticket Serial',
    axis: 'Axis',
    stop: 'Stop',
    vehicle: 'Vehicle',
    timeAndDate: 'Time & Date',
    createdAtDate: 'Created At Date',
    baseAmount: 'Base Amount',
    trip: 'Trip',
    fromDate: 'From Date',
    toDate: 'To Date',
    addAxis: 'Add Axis',
    selectAStop: 'Select a stop',
    addStop: 'Add Stop',
    stops: 'Stops',
    price: 'Price',
    successdeleteaxis: 'The Axis has been deleted successfully',
    successAddAxis: 'The Axis has been added successfully',
    successEditAxis: 'The Axis has been edited successfully',
    editAxis: 'Edit Axis',
    dragRowsToReorder: 'Drag rows to reorder',
    priceEGP: 'Price (EGP)',
    _stops: 'Stops',
    priceNumberValidation: 'Price must be numbers only',
    nextPage: 'Next Page',
    previousPage: 'Previous Page',
    nogroup: 'No Groups',
    createAdmin: 'Create Admin',
    passwordRulesNotMatchMessage:
      'Password must be at least 6 characters and contain at least one letter',
    plateNumber: 'Plate Number',
    addVehicle: 'Add Vehicle',
    editVehicle: 'Edit Vehicle',
    vehicleInfo: 'Vehicle Info',
    type: 'Type',
    vehicles: 'Vehicles',
    backToVehiclesList: 'Back To Vehicles List',
    color: 'Color',
    modelYear: 'Model Year',
    successEditVehicle: 'You have successfully edited vehicle!',
    successAddVehicle: 'You have successfully added vehicle!',
    successdeletevehicle: 'You have successfully deleted vehicle!',
    vehicleType: 'Vehicle Type',
    vehicleTypes: 'Vehicle Types',
    searchByVehicleCodeOrPlateNumber: 'Search by Vehicle Code or Plate Number',
    vehicleCode: 'Vehicle Code',
    vehicleModelYear: 'Vehicle Model Year',
    noGroupFound: 'No Group Found',
    noOrganizationFound: 'No Organization Found',
    devices: 'Devices',
    ip: 'IP',
    serial: 'Serial',
    deviceInfo: 'Device Info',
    device: 'Device',
    backToDevicesList: 'Back To Devices List',
    addDevice: 'Add Device',
    editDevice: 'Edit Device',
    successEditDevice: 'You have succussfully edited device!',
    successAddDevice: 'You have succussfully added device!',
    successdeletedevice: 'You have succussfully deleted device!',
    deviceType: 'Device Type',
    deviceTypes: 'Device Types',
    searchByDeviceCodeOrSerial: 'Search by Device Code or Serial',
    devicesManagement: 'Devices Management',
    createDevice: 'Create Device',
    unassigned: 'Unassigned',
    vehiclesManagement: 'Vehicles Management',
    successdeleteroute: 'The Route has been deleted successfully',
    adminManagement: 'Admin Management',
    addGroup: 'Add Group',
    successAddGroup: 'You have successfully added group!',
    successEditGroup: 'You have successfully edited group!',
    editGroup: 'Edit Group',
    successdeletegroup: 'The Group has been deleted successfully',
    backToGroupsList: 'Back To Groups List',
    groupInfo: 'Group Info',
    minLengthOneValidation: 'This Field must have at least 1 item',
    stations: 'Stations',
    station: 'Station',
    addStation: 'Add Station',
    editStation: 'Edit Station',
    stationInfo: 'Station Info',
    stationName: 'Station Name',
    stationCode: 'Station Code',
    stationCodeAlphanumeric:
      'Station code must start with letters and end with numbers (e.g. ABC123)',
    stationCodeUpdateFailed: 'Failed to update station code',
    stopCode: 'Stop Code',
    stopCodeAlphanumeric:
      'Stop code must start with letters and end with numbers (e.g. WAYZ123)',
    stopCodeUpdateFailed: 'Failed to update stop code',
    importStations: 'Import Stations',
    importStops: 'Import Stops',
    successAddStation: 'You have successfully added station!',
    successEditStation: 'You have successfully edited station!',
    successdeletestation: 'You have successfully deleted station!',
    successUploadStations: 'Stations file uploaded successfully',
    successUploadStops: 'Stops file uploaded successfully',
    noStationsFound: 'No Stations Found',
    noStations: 'No Stations',
    backToStationsList: 'Back To Station List',
    assignToGroup: 'Assign To Group',
    unAssignFromGroups: 'Unassign From Groups',
    codeNumberValidation: 'Code must be numbers only',
    codeLengthValidation: 'Code must equal 3 digits',
    editStop: 'Edit Stop',
    longitude: 'Longitude',
    latitude: 'Latitude',
    lonNumberValidation: 'Longitude must be numbers only',
    latNumberValidation: 'Latitude must be numbers only',
    confirmunAssignFromGroupsMessage:
      'Are you sure you want to unassign from groups selected',
    successEditStop: 'You have successfully edited stop!',
    successAddStop: 'You have successfully added stop!',
    successdeletestop: 'You have successfully deleted stop!',
    assigned: 'Assigned',
    assignDeviceToVehicle: 'Assign Device To Vehicle',
    changeDevice_serial: 'Change Device {serial}',
    fromVehicle_Code_to: 'From Vehicle Code {from} to',
    assignDevice_serial: 'Assign Device {serial}',
    toVehicleCode: 'To Vehicle Code',
    assignedTo_code: 'Assigned To {code}',
    assignDeviceToVehicleMsg:
      'Are you sure you want to change device {serial} from vehicle code {currentVehicleCode} to {code}',
    stationList: 'Station List',
    vehicleClass: 'Vehicle Class',
    vehicleClasses: 'Vehicle Classes',
    addVehicleClass: 'Add Vehicle Class',
    editVehicleClass: 'Edit Vehicle Class',
    vehicleClassInfo: 'Vehicle Class Info',
    successAddVehicleClass: 'You have successfully added vehicle class!',
    successEditVehicleClass: 'You have successfully edited vehicle class!',
    successdeletevehicleClass: 'You have successfully deleted vehicle class!',
    noVehicleClassFound: 'No Vehicle Class Found',
    noVehicleClassesFound: 'No Vehicle Classes Found',
    backToVehicleClassesList: 'Back To Vehicle Classes List',
    avgSpeedNumberValidation: 'Average Speed must be numbers only',
    averageSpeed: 'Average Speed',
    addVehicleType: 'Add Vehicle Type',
    editVehicleType: 'Edit Vehicle Type',
    vehicleTypeInfo: 'Vehicle Type Info',
    successAddVehicleType: 'You have successfully added vehicle type!',
    successEditVehicleType: 'You have successfully edited vehicle type!',
    successdeletevehicleType: 'You have successfully deleted vehicle type!',
    noVehicleTypeFound: 'No Vehicle Type Found',
    noVehicleTypesFound: 'No Vehicle Types Found',
    backToVehicleTypesList: 'Back To Vehicle Types List',
    capacity: 'Capacity',
    capacityValidation: 'Capacity must be numbers only',
    searchByVehicleCode: 'Search by Vehicle Code',
    selectAGroup: 'Select a group',
    organizationAccess: 'Organization Access',
    searchByCode: 'Search by Code',
    searchByVehicleCodeOrSerial: 'Search by Vehicle Code or Serial',
    deviceIdentifier: 'Device Identifier',
    ipIsInvalid: 'IP is invalid',
    changeDeviceOrgMsg:
      'If you changed the organization of the device, the current vehicle will be unassigned from the device',
    changeVehicleOrgMsg:
      'If you changed the organization of the vehicle, the vehicle will be unassigned from the current device',
    cash: 'Cash',
    card: 'Card',
    cashPriceEGP: 'Cash Price (EGP)',
    cardPriceEGP: 'Card Price (EGP)',
    successChangePassword: 'You have successfully changed your password!',
    importMissingField: 'The field "{fieldName}" is missing',
    groupNotFound: 'Group "{groupName}" not found for this organization',
    importErrorAtRecord: 'Error at row number {rowNum}: {error}',
    importRemoteErrorAtRecord: 'Error at {rowNum}: {error}',
    importFileTooBig3MB: 'File size is bigger than 3 MB',
    vehicleTypeNotFound: 'Vehicle Type not found',
    successImportMessage: 'You have successfully imported {count} records',
    app_title: "Mwasalat Misr",
    language: "Language",
    welcome_message: "Welcome",
    days_since_release: "it's been {{number_of_days}} days since this video was released",
    NoDateAvailable: "No Data Available",
    LoginAgain: "You Should Login Again",
    From: " From",
    WelcomeTo: "Welcome To",
    PleaseLoginToAccessYourAccount: "Please Login To Access Your Account",
    clearAll2: "Reset",
    CashPrice: "Cash Price ",
    CardPrice: "Card Price",
    AxisInfo: " Axis Info",
    BackToHome: "Back",
    MakeSureYouHaveOpPermission: "Make Sure You Have Needed Operations Sub Systems Permissons",
    YouAreNotAllowedToDoThis: "You Are Not Allowed To Do This",
    YouHaveNoAccess: "You Have No Access",
    ObjWSIdNotFound: "Object with the specified ID not found.",
    ThisActionNeedToGrantControlForRoutesOfTheOrganisationFirst: "This Action Need To Grant Control For Routes Of The Organisation First",
    ThisActionNeedToDenyControlForFaresOfTheOrganisationFirst: "This Action Need To Deny Control For Fares Of The Organisation First",
    Grant: "Grant",
    Deny: "Deny",
    Atten: "Attention Please",
    CantGetImportantUsedDataFromGroupsApi: "Can't Get Important Used  Data From Groups Api , Please Back And Try Again",
    NoMessageFound: "Waiting...",
    someThingWentWrongError: " Something Went Wrong , Please Back And Try Again",
    noteFaresSybPermissonsChangedToBeLikeRoutesPermissions: " Warning : Any Changes In Routes Permissions May Be Affect On Fares Permissions ",
    errorWhenApplyingPermissionsInGrantFaresReadonlyAccessPleaseTryAgain: "Error When Applying Permissions In Grant Fares Readonly Access , Please  Add It Manually",
    errorWhenApplyingPermissionsInGrantFaresFullControlAccessPleaseTryAgain: "Error When Applying Permissions In Grant Fares Full Access , Please  Add It Manually",
    errorWhenApplyingPermissionsInRoutesPleaseTryAgain: "Error When Applying Permissions In Routes, Please  Add It Manually",
    AnErrorHappend: " There Is An Error Happend",
    SuccessOperationHappend: "Operation completed successfully",
    yourAvailableBalance: "Your Available Balance",
    StopsNumber: " Stops Number",
    StopsInfo: " Stops Info",
    zones: "Zones",
    zone: "Zone",
    AddZone: " Add Zone",
    NameCode: "Name (Code)",
    BaseFare: "Base Fare (Cash / Card)",
    CuSym: " L.E ",
    ZoneInfo: "Zone Info",
    ThisStopIsIn: "This Stop Is In",
    // Zoning Routes > axis: add / edit / delete zone toasts
    // (delete + edit reuse the shared DeletedSuccessfully / UpdatedSuccessfully keys)
    AddedSuccessfully: "Added Successfully",
    EmptyFields: "Empty Fields",
    PriceEnteredIsVeryHigh: "Price Entered Is Very High",
    NameEnteredIsVeryHigh: "Name Entered Is Very High",
    ZoneActionFailedRetry: "Sorry , {err} , Please Try Again Later Or Try Refresh Page , Code : {code}",
    ZoneActionFailed: "Sorry , {err} , Code : {code}",
    loginErr1: "You Should Enter Username And Password",
    loginErr2: "Error In User Name Or Password",
    loginSuccess: "Login Successfully",
    RemoveMarker: "Remove",
    WaitMessage: "Wait for the data to load, if it takes too long, reload the page",
    SearchByFareMediaSerial: "Enter Serial Of Fare Media",
    transID: "TN",
    ticketPrice: "Base Amount",
    amountAfterDiscount: 'Amount After Discount',
    discountBandCode: 'Discount Code',
    isOffline: 'Is Offline',
    online: 'Online',
    offline: 'Offline',
    assignmentLink: 'Assignment',
    assignmentLinkBtn: 'View Assignment',
    SelectGroupFirst: 'Please select a Passengers Group first',
    discountTypeCode: 'Discount Type',
    discountBandPctAmount: 'Discount Value',
    internal_id: 'Internal ID',
    ticketDate: " Date & Time ",
    driverName: "Driver Name",
    driverUserName: "Driver Username",
    axisName: " Axis Name",
    deviceSerialNumber: "Device Serial Number",
    endDate: "End Date",
    startDate: "Start Date",
    transactionsNumber: "Total Count :",
    transactionsTotalAmount: "Total Amount :",
    ResetFilter: "Reset Filter",
    NoFareMediaExist: "No Data Available For This Serial",
    serial_num: "Serial Number",
    uid: "UID",
    parent_wallet_balance: "Balance",
    fare_media_type_name: "Type",
    is_blacklisted: "Blacklisted",
    issuer_name: "Issuer",
    account_id: "Account Number",
    init_balance: "Initial Balance",
    org_name: "Organization",
    created_at: "Creation Date",
    updated_at: "Last Update At",
    tickets: "Tickets",
    charging: "Charging",
    deviceLimitErrorMsg: "Sorry, you have reached your limit",
    user_name: "Owner Name",
    user_phone: "Owner Phone",
    user_email: "Owner Email",
    expiration_date: "Expiration Date",
    AFCReports: "AFC Reports",
    CardsReports: "Cards Reports",
    OperationsReports: "Operations Reports",
    CardsManagement: "Cards Management",
    Merchants: "Merchants",
    MerchantPOS: "Merchant POS",
    ChargingTransactions: "Charging Transactions",
    AddNewMerchant: "Add New Merchant",
    AddMerchant: "Add Merchant",
    MerchantNameEn: "Merchant Name (English)",
    MerchantNameAr: "Merchant Name (Arabic)",
    MerchantStatus: "Status",
    Adding: "Adding...",
    EditMerchant: "Edit Merchant",
    Updating: "Updating...",
    AddNewMerchantPOS: "Add New Merchant POS",
    AddMerchantPOS: "Add Merchant POS",
    EditMerchantPOS: "Edit Merchant POS",
    UserLimit: "Limit",
    SelectMerchant: "Select Merchant",
    POSName: "POS Name",
    POSCount: "POS Count",
    Of: "of",
    MerchantInfo: "Merchant Info",
    BackToMerchants: "Back To Merchants",
    MerchantName: "Merchant Name",
    MerchantPOSName: "Name",
    SearchByPOSName: "Search By POS Name",
    MerchantPOSInfo: "Merchant POS Info",
    BackToMerchantPOS: "Back To Merchant POS",
    POSStatus: "POS Status",
    MerStatus: "Merchant Status",
    FareMediaSerial: " Serial Number",
    TransactionNumber: "TN",
    FareMediaAmount: "Fare Media Balance",
    SearchByTransactionNumber: "Search By Transaction Number",
    POSSerialNumber: "POS Serial Number",
    FareMedia: "Fare Media",
    AddFareMedia: "Add Fare Media",
    AddNewFareMedia: "Add New Fare Media",
    SellingPrice: "Selling Price",
    DownloadTemplate: "Download Template",
    UploadFile: "Upload File",
    Uploading: "Uploading ...",
    deviceSN: "Device SN",
    NewBalance: "New Balance",
    SN: "SN",
    Vat: "Vat",
    TotalFees: "Fees",
    PaidAmount: "Paid Amount",
    SearchBySerial: "Search By Serial Number",
    selling_price: "Selling Price",
    Selling: "Selling",
    sold_date: "Sold Date",
    ar_fare_media_type_name: " Fare Media Type (AR) ",
    ar_issuer_name: " Issuer (AR) ",
    ar_org_name: " Organization (AR) ",
    Reports: "Reports",
    EditFareMedia: "Edit Fare Media",
    Blacklisted_note: "The Reason",
    is_sold: "Sold",
    issuing_date: "Issuing Date",
    distribution_date: "Distribution Date",
    total_charging_amount: "Total Charging Amount",
    total_ticketing_amount: "Total Ticketing Amount",
    calculated_balance: "Balance Based On Charging & Ticketing ",
    addToFareMediaBalance: "Adding To Fare Media Balance",
    removeFareMediaBalance: "Remove From Fare Media Balance",
    BalanceIsCorrect: "Balance Is Correct",
    BalanceNotes: "Balance Notes",
    FareMediaInfo: "Fare Media Info",
    currency: "EGP",
    loading: "Loading ...",
    Logs: "Logs",
    request: "Request",
    response: "Response",
    SelectCommission_type: "Select Commission Type",
    commissionType: "Commission Type",
    com_prov: "Com Prov",
    com_ret: "Com Ret",
    flat_fee: "Flat Fee",
    Commissions: "Commissions",
    unCalcYet: "Not Yet Calculated",
    multi_org: "Multi Org",
    Select_Organization: "Select Organization",
    Not_Allowed_to_edit: "Only cards blocked by the admins are allowed to be unblocked",
    allowed_multi_org: " ( Allowed Multi )",
    not_allowed_multi_org: "( Not Allowed Multi )",
    both: 'Both',
    transactionAmount: 'Amount',
    cardSerial: 'Card Serial',
    merchantRef: 'Merchant Ref',
    ticket: 'Ticket',
    description: "Description",
    channel: "Channel",
    debit: "Debit",
    credit: "Credit",
    balance: "Balance",
    chargingOperation: "Charging ",
    ticketingOperation: "Ticketing ",
    reversalOperation: "Reversal ",
    initBalanceOperation: "Initial Balance",
    feesDeductedOnCharging: "Charging Fees",
    vatDeductedOnCharging: "Charging VAT",
    transferFromWalletOperation: "Transfer From Wallet",
    transferToWalletOperation: "Transfer To Wallet",
    migrationOperation: "Migration",
    totalAmount: 'Current Balance',
    totalCredits: 'Total Credit',
    totalDebits: 'Total Debit',
    accountStatementTotalsLabel: 'Totals [EGP]:',
    displayedTotalAmount: 'Displayed Total Amount',
    displayedTotalCredits: 'Displayed Total Credits',
    displayedTotalDebits: 'Displayed Total Debits',
    TotalDisplayed: "Total Displayed",
    AccountStatement: "Account Statement",
    NoOfTransactions: "No. Of Transactions",
    Settlements: "Settlements",
    SettlementTransactions: "Company Settlement ",
    // Settlement Transactions
    settlement_Date: "Date",
    settlement_Sender: "Sender",
    settlement_Beneficiary: "Beneficiary",
    settlement_Type: "Type",
    settlement_Period: "Period",
    settlement_Amount: "Amount",
    settlement_Status: "Status",
    settlement_Actions: "Actions",
    settlement_All: "All",
    settlement_Draft: "Draft",
    settlement_Confirmed: "Confirmed",
    settlement_Cleared: "Cleared",
    settlement_Reversed: "Reversed",
    settlement_ContinueConfirm: "Continue & Confirm",
    settlement_Continue: "Continue",
    settlement_Clear: "Clear",
    settlement_ClearSettlement: "Clear Settlement",
    settlement_Reverse: "Reverse",
    settlement_ReverseSettlement: "Reverse Settlement",
    settlement_SettlementIsCleared: "Settlement is cleared - cannot be reversed",
    settlement_SearchPlaceholder: "Search sender/beneficiary/type",
    settlement_Refresh: "Refresh",
    settlement_NewSettlement: "New Settlement",
    settlement_FailedToLoad: "Failed to load settlements",
    settlement_MarkAsCleared: "Mark as Cleared",
    settlement_ACHReferenceNo: "ACH Reference No.",
    settlement_PleaseEnterACHRef: "Please enter ACH Reference No.",
    settlement_EnterBankRefNumber: "Enter bank reference number",
    settlement_Description: "Description",
    settlement_PleaseEnterDescription: "Please enter a description",
    settlement_NoDescriptionEntered: "No Description Entered",
    settlement_DescriptionPlaceholder: "e.g. Transferred Q1 Settlement",
    settlement_TransferDate: "Transfer Date",
    settlement_PleaseSelectTransferDate: "Please select transfer date",
    settlement_TransferDateCannotBeFuture: "Transfer date cannot be in the future",
    settlement_ToDateCannotBeFuture: "To date cannot be in the future",
    settlement_SelectDate: "Select Date",
    settlement_SettlementConfirmed: "Settlement Confirmed",
    settlement_MarkedAsCleared: "Settlement marked as Cleared",
    settlement_FailedToClear: "Failed to clear settlement",
    settlement_ReversalReason: "Reversal Reason",
    settlement_PleaseEnterReversalReason: "Please enter a reversal reason",
    settlement_EnterReasonForReversal: "Enter the reason for reversal",
    settlement_ReversedSuccessfully: "Settlement reversed successfully",
    settlement_FailedToReverse: "Failed to reverse settlement",
    settlement_ReversedAt: "Reversed At",
    settlement_ReversedBy: "Reversed By",
    settlement_ReversalInformation: "Reversal Information",
    settlement_CreatedAt: "Created At",
    settlement_AddSettlementTransaction: "Add Settlement Transaction",
    settlement_PartiesPeriod: "Parties & Period",
    settlement_SelectSenderBeneficiaryPeriod: "Select sender, beneficiary and settlement period",
    settlement_TransactionSummary: "Transaction Summary",
    settlement_ReviewTransactionsSelectChannels: "Review transactions and select channels",
    settlement_FinancialAccounts: "Financial Accounts",
    settlement_MapAccountsForERP: "Map accounts for ERP journal suggestions",
    settlement_BankTransfer: "Bank Transfer",
    settlement_SelectBankAccountsAddNotes: "Select bank accounts and add notes",
    settlement_Review: "Review",
    settlement_ReviewConfirmSettlement: "Review and confirm settlement",
    settlement_Back: "Back",
    settlement_SaveAsDraft: "Save as Draft",
    settlement_Next: "Next",
    settlement_ReviewSettlement: "Review Settlement",
    settlement_ConfirmSettlement: "Confirm Settlement",
    settlement_SavingDraft: "Saving draft...",
    settlement_DraftSaved: "Draft saved",
    settlement_FailedToSaveDraft: "Failed to save draft",
    settlement_SaveDraftStep1Only: "Save Draft (Step 1 only)",
    settlement_OnlyStep1WillBeSaved: "Only Step 1 (Parties & Period) will be saved to the draft.",
    settlement_DataFromOtherStepsWillNotBeSaved: "Data from other steps (Transaction Summary, Financial Accounts, Bank Transfer) will NOT be saved.",
    settlement_DoYouWantToContinue: "Do you want to continue?",
    settlement_SaveStep1Only: "Save Step 1 Only",
    settlement_DraftSavedStep1Only: "Draft saved (Step 1 only)",
    settlement_SettlementSavedAsDraft: "Settlement saved as draft",
    settlement_YouAreAboutToCreate: "You are about to create a confirmed settlement:",
    settlement_ThisActionCannotBeEdited: "This action cannot be canceled after confirmation.",
    settlement_ConfirmAndClose: "Confirm & Close",
    settlement_BankAccountsMustBeSelected: "Bank accounts must be selected. Please go back to Step 4 and select bank accounts.",
    settlement_CreatedAndConfirmedSuccessfully: "Settlement created and confirmed successfully",
    settlement_FailedToCreate: "Failed to create settlement",
    settlement_PostConfirmationViewSettlement: "Post-Confirmation: View Settlement",
    settlement_PrintSettlement: "Print Settlement",
    settlement_SettlementHasBeenCleared: "âœ“ Settlement has been cleared and cannot be modified",
    settlement_Close: "Close",
    close: "Close",
    settlement_PleaseAllowPopups: "Please allow popups to view the PDF preview",
    settlement_PDFPreviewOpened: "PDF preview opened in new tab",
    settlement_FailedToOpenPDFPreview: "Failed to open PDF preview",
    settlement_SettlementDetails: "Settlement Details",
    settlement_PeriodLabel: "Period",
    settlement_From: "From",
    settlement_To: "To",
    settlement_SenderOurCompany: "Sender (Our Company)",
    settlement_Organisation: "Organisation",
    settlement_Bank: "Bank",
    settlement_BankAccount: "Bank Account",
    settlement_SenderNotSelected: "Sender not selected",
    settlement_BeneficiaryPTO: "Beneficiary (PTO)",
    settlement_BeneficiaryNotSelected: "Beneficiary not selected",
    settlement_AmountCurrency: "Amount & Currency",
    settlement_Currency: "Currency",
    settlement_SuggestedERPJournalEntrySender: "Suggested ERP Journal Entry (Sender)",
    settlement_Account: "Account",
    settlement_Debit: "Debit",
    settlement_Credit: "Credit",
    settlement_Total: "Total",
    settlement_SuggestedERPJournalEntryBeneficiary: "Suggested ERP Journal Entry (Beneficiary)",
    settlement_BankTransferDetails: "Bank Transfer Details",
    settlement_ACHReference: "ACH Reference",
    settlement_BankTransferNotes: "Bank Transfer Notes",
    settlement_NoAdditionalNotes: "No additional notes",
    settlement_SenderBankNotSelected: "Sender bank not selected",
    settlement_BeneficiaryBankNotSelected: "Beneficiary bank not selected",
    settlement_SenderAccountNotSelected: "Sender account not selected",
    settlement_BeneficiaryAccountNotSelected: "Beneficiary account not selected",
    settlement_Channel: "Channel",
    settlement_Transactions: "Transactions",
    settlement_GrossAmount: "Gross Amount",
    settlement_Fees: "Fees",
    settlement_VAT: "VAT",
    settlement_AmountToSettle: "Amount to Settle",
    settlement_OurBank: "Our Bank?",
    settlement_Include: "Include?",
    settlement_FailedToLoadInitialData: "Failed to load initial data",
    settlement_SettlementType: "Settlement Type",
    settlement_SelectSettlementType: "Select settlement type",
    settlement_PleaseSelectSettlementType: "Please select a settlement type",
    settlement_SenderOrganisation: "Sender Organisation",
    settlement_SelectSenderOrganisation: "Select sender organisation",
    settlement_PleaseSelectSenderOrganisation: "Please select a sender organisation",
    settlement_BeneficiaryOrganisation: "Beneficiary Organisation",
    settlement_SelectBeneficiaryOrganisation: "Select beneficiary organisation",
    settlement_PleaseSelectBeneficiaryOrganisation: "Please select a beneficiary organisation",
    settlement_FromDate: "From Date",
    settlement_PleaseSelectFromDate: "Please select a from date",
    settlement_ToDate: "To Date",
    settlement_PleaseSelectToDate: "Please select a to date",
    settlement_Notes: "Notes",
    settlement_AddNotesOptional: "Add notes (optional)",
    settlement_FailedToLoadTransactionData: "Failed to load transaction data",
    settlement_LoadingTransactions: "Loading transactions...",
    settlement_NoDataAvailable: "No data available",
    settlement_NoTransactionsFound: "No transactions found for the selected period",
    settlement_SelectAtLeastOneChannel: "Please select at least one channel to include",
    settlement_FailedToLoadAccounts: "Failed to load accounts",
    settlement_LoadingAccounts: "Loading accounts...",
    settlement_SenderAccounts: "Sender Accounts",
    settlement_DebitAccount: "Debit Account",
    settlement_SelectDebitAccount: "Select debit account",
    settlement_PleaseSelectDebitAccount: "Please select a debit account",
    settlement_CreditAccount: "Credit Account",
    settlement_SelectCreditAccount: "Select credit account",
    settlement_PleaseSelectCreditAccount: "Please select a credit account",
    settlement_IncomeAccount: "Income Account",
    settlement_SelectIncomeAccount: "Select income account",
    settlement_PleaseSelectIncomeAccount: "Please select an income account",
    settlement_TaxLiabilityAccount: "Tax Liability Account",
    settlement_SelectTaxLiabilityAccount: "Select tax liability account",
    settlement_PleaseSelectTaxLiabilityAccount: "Please select a tax liability account",
    settlement_BeneficiaryAccounts: "Beneficiary Accounts",
    settlement_ExpenseAccount: "Expense Account",
    settlement_SelectExpenseAccount: "Select expense account",
    settlement_PleaseSelectExpenseAccount: "Please select an expense account",
    settlement_TaxAssetAccount: "Tax Asset Account",
    settlement_SelectTaxAssetAccount: "Select tax asset account",
    settlement_PleaseSelectTaxAssetAccount: "Please select a tax asset account",
    settlement_FailedToLoadBanks: "Failed to load banks",
    settlement_LoadingBanks: "Loading banks...",
    settlement_SenderBank: "Sender Bank",
    settlement_SelectSenderBank: "Select sender bank",
    settlement_PleaseSelectSenderBank: "Please select a sender bank",
    settlement_BeneficiaryBank: "Beneficiary Bank",
    settlement_SelectBeneficiaryBank: "Select beneficiary bank",
    settlement_PleaseSelectBeneficiaryBank: "Please select a beneficiary bank",
    settlement_SettlementSummary: "Settlement Summary",
    settlement_NetAmountToSettle: "Net Amount to Settle",
    settlement_TotalFees: "Total Fees",
    settlement_TotalVAT: "Total VAT",
    settlement_SelectedChannels: "Selected Channels",
    settlement_EGP: "EGP",
    settlement_EGPEgyptianPound: "EGP - Egyptian Pound",
    settlement_AutoCalculatedBasedOnPrevious: "Auto-calculated based on previous settlements",
    settlement_PleaseSelectEndDate: "Please select end date",
    settlement_UnsettledDuesAccountAsset: "Unsettled Dues Account (Asset)",
    settlement_PleaseSelectUnsettledDuesAccount: "Please select unsettled dues account",
    settlement_PTOReceivableMidar: "e.g., 'PTO Receivable - Midar', #11200",
    settlement_BankAccountAsset: "Bank Account (Asset)",
    settlement_PleaseSelectBankAccount: "Please select bank account",
    settlement_BankAccountNBE: "e.g., 'Bank Account - NBE', #10100",
    settlement_CommissionIncome: "e.g., 'Commission Income', #40100",
    settlement_VATPayable: "e.g., 'VAT Payable', #20300",
    settlement_DebitAccountAsset: "Debit Account (Asset)",
    settlement_OperatingAccount: "e.g., 'Operating Account', #10100",
    settlement_CreditAccountIncome: "Credit Account (Income)",
    settlement_FareRevenue: "e.g., 'Fare Revenue', #40100",
    settlement_CommissionExpense: "e.g., 'Commission Expense', #50100",
    settlement_VATAssetAccount: "VAT Asset Account",
    settlement_VATReceivable: "e.g., 'VAT Receivable', #10200",
    settlement_SelectSenderBankAccount: "Select sender bank account",
    settlement_SelectBeneficiaryBankAccount: "Select beneficiary bank account",
    settlement_AdditionalNotes: "Additional Notes",
    settlement_SuggestedERPJournalEntry: "Suggested ERP Journal Entry",
    settlement_RecommendedJournalEntries: "Recommended Journal Entries",
    settlement_SenderAccountMapping: "Sender Account Mapping",
    settlement_BeneficiaryAccountMapping: "Beneficiary Account Mapping",
    settlement_SettlementPeriod: "Settlement Period",

    // Additional untranslated texts from wizard and table (only new unique keys)
    settlement_SelectSenderAndBeneficiary: "Select Sender and Beneficiary",
    settlement_TransactionSummaryTitle: "Transaction Summary",
    settlement_SettlementTypeLabel: "Settlement Type:",
    settlement_SenderOurCompanyLabel: "Sender (Our Company):",
    settlement_BeneficiaryLabel: "Beneficiary:",
    settlement_PeriodLabelShort: "Period:",
    settlement_SelectChannelsToInclude: "Select Channels to Include",
    settlement_NetSettlementZeroOrNegative: "Net Settlement is zero or negative. Please adjust selected channels to proceed.",
    settlement_MapFinancialAccountsForERP: "Map Financial Accounts (For ERP Journal Suggestion)",
    settlement_ERPJournalSuggestionsOnly: "ERP Journal Suggestions Only",
    settlement_ERPJournalSuggestionsDescription: "These accounts will be used to generate the suggested journal entry for ERP. This is not a full accounting system - just suggestions for export to your ERP.",
    settlement_SenderAccountsMwaslaTech: "Sender Accounts (MwaslaTech)",
    settlement_BeneficiaryAccountsSuggestedForERP: "Beneficiary Accounts (Suggested for ERP)",
    settlement_AutoFillFromDefaultERPMappings: "Auto-Fill from Default ERP Mappings",
    settlement_SuggestedJournalEntryForERP: "ðŸ§¾ Suggested Journal Entry for ERP",
    settlement_ERPJournalSuggestionBalanced: "ERP Journal Suggestion (Balanced)",
    settlement_ERPJournalSuggestionDescription: "This is a suggestion only â€” not a full accounting entry. Used to generate PDF journal suggestion for ERP posting.",
    settlement_FieldReference: "Field Reference",
    settlement_Balanced: "âœ… Balanced",
    settlement_JournalEntryExplanation: "Journal Entry Explanation",
    settlement_BankTransferDetailsTitle: "Bank Transfer Details",
    settlement_SenderOurCompanyShort: "Sender (Our Company):",
    settlement_BeneficiaryPTOShort: "Beneficiary (PTO):",
    settlement_LoadingBankAccounts: "Loading bank accounts...",
    settlement_OptionalNotesPlaceholder: "Optional notes for audit trail (e.g., Monthly net settlement for Q1 2025)",
    settlement_ReviewSettlementTitle: "Review Settlement",
    settlement_AmountAndCurrency: "Amount & Currency",
    settlement_SuggestedERPJournalEntrySenderTitle: "Suggested ERP Journal Entry (Sender)",
    settlement_SuggestedERPJournalEntryBeneficiaryTitle: "Suggested ERP Journal Entry (Beneficiary)",
    settlement_BankTransferNotesTitle: "Bank Transfer Notes",
    settlement_LoadingFinancialAccounts: "Loading financial accounts...",
    settlement_FailedToLoadBankAccountsError: "Failed to load bank accounts: ",

    // Missing translation keys
    settlement_VATLiabilityAccount: "VAT Liability Account",

    // Account names without codes
    settlement_UnsettledDues: "Unsettled Dues",
    settlement_BankAccountAssetName: "Bank Account",
    settlement_CommissionIncomeAccount: "Commission Income",
    settlement_VATPayableAccount: "VAT Payable",
    settlement_OperatingAccountName: "Operating Account",
    settlement_FareRevenueAccount: "Fare Revenue",
    settlement_CommissionExpenseAccount: "Commission Expense",
    settlement_VATReceivableAccount: "VAT Receivable",

    // Description translations
    settlement_ClearUnsettledDuesLiability: "Clear unsettled dues liability",
    settlement_NetCashTransferredToPTO: "Net cash transferred to PTO",
    settlement_VATOnFeesTotal: "VAT on fees (total)",
    settlement_TotalFeesEarnedSummed: "Total fees earned (summed)",
    settlement_NetCashReceivedFromSender: "Net cash received from sender",
    settlement_CommissionExpenseTotal: "Commission expense (total)",
    settlement_VATOnCommissionTotal: "VAT on commission (total)",
    settlement_RecognizeFareRevenue: "Recognize fare revenue",
    settlement_RecognizeFareRevenueAndFeesTotal: "Recognize fare revenue and fees (total)",
    settlement_DescriptionLabel: "Description",

    // Status translations
    settlement_StatusLabel: "Status",
    settlement_StatusDraft: "Draft",
    settlement_StatusConfirmed: "Confirmed",
    settlement_StatusCleared: "Cleared",
    settlement_StatusReversed: "Reversed",
    settlement_StatusPending: "Pending",

    // Currency translations
    settlement_CurrencyEGP: "EGP",

    // Additional PDF translations
    settlement_ACHReferenceNumber: "ACH Reference Number",
    settlement_TransferDateLabel: "Transfer Date",
    settlement_FinanceManager: "Finance Manager",
    settlement_GeneralManager: "General Manager",
    settlement_NameLabel: "Name",
    settlement_DateLabel: "Date",
    settlement_Signature: "Signature",
    settlement_AFCSettlementSystem: "AFC Settlement System",
    settlement_GeneratedOn: "Generated on",
    settlement_SettlementReport: "Settlement Report",
    settlement_SettlementIDLabel: "Settlement ID",
    settlement_AmountToSettleLabel: "Amount to Settle",
    settlement_NoBankTransferDetailsEntered: "No bank transfer details entered yet",

    // Button translations
    settlement_Print: "Print",
    settlement_Download: "Download",
    settlement_DownloadTextPDF: "Download Text PDF",

    // Yes/No translations
    settlement_Yes: "Yes",
    settlement_No: "No",

    // Action translations
    settlement_ContinueAndConfirm: "Continue & Confirm",
    settlement_CompleteCurrentStepFirst: "Please complete the current step before proceeding to the next step",
    settlement_NoUnsettledTransactions: "This organisation has no unsettled transactions. No settlement is needed.",

    Banks: "Banks",
    OrganisationBanks: "Organisation Banks",
    FinancialAccounts: "Financial Accounts",

    BankNameAr: "Bank Name (Arabic)",
    BankNameEn: "Bank Name (English)",
    BankNameEnglish: "Bank Name (English)",
    BankNameArabic: "Bank Name (Arabic)",
    SwiftCode: "Swift Code",
    SearchBankNameSwiftCode: "Bank name, Swift code",

    AddNewBank: "Add New Bank",
    BankAddedSuccessfully: "Bank Added Successfully",
    AreYouSureDeleteBank: "Are you sure you want to delete this bank?",

    AddNewOrganisationBank: "Add New Organisation Bank",
    OrganisationBankAddedSuccessfully: "Organisation Bank Added Successfully",
    AddOrganisationBank: "Add Organisation Bank",
    AreYouSureDeleteOrganisationBank: "Are you sure you want to delete this bank?",
    OrganisationNameEnglish: "Organisation Name",

    // AddEntity Component
    SelectOption: "Select an option",
    SelectDependencyFirst: "Please select the required field first",

    // Organisation Bank Fields
    AccountName: "Account Name",
    AccountNumber: "Account Number",
    IBAN: "IBAN",
    BranchName: "Branch Name",
    BranchAddress: "Branch Address",
    BeneficiaryEmail: "Beneficiary Email",
    BeneficiaryMobile: "Beneficiary Mobile",
    Organisation: "Organisation",
    Bank: "Bank",
    FinancialAccount: "Financial Account",
    SearchOrganisationBankPlaceholder: "Search by account name, number, IBAN, or branch",

    // Financial Accounts
    AddNewFinancialAccount: "Add New Financial Account",
    FinancialAccountAddedSuccessfully: "Financial Account Added Successfully",
    AreYouSureDeleteFinancialAccount: "Are you sure you want to delete this account?",
    SearchFinancialAccountPlaceholder: "Search by name, description, account number",
    AccountType: "Account Type",
    ParentAccount: "Parent Account",
    FinancialAccountInfo: "Financial Account Information",
    BackToFinancialAccounts: "Back to Financial Accounts",
    EditFinancialAccount: "Edit Financial Account",
    MyAccount: "My Account",

    // ViewEntity Component
    BankInfo: "Bank Information",
    OrganisationBankInfo: "Organisation Bank Information",
    BankName: "Bank Name",
    CreatedAt: "Created At",
    UpdatedAt: "Updated At",
    BackToBanks: "Back to Banks",
    BackToOrganisationBanks: "Back to Organisation Banks",
    DeletedSuccessfully: "Deleted Successfully",
    Deleting: "Deleting...",

    // EditEntity Component
    EditBank: "Edit Bank",
    EditOrganisationBank: "Edit Organisation Bank",
    UpdatedSuccessfully: "Updated Successfully",

    // Permission Messages
    YouDontHavePermissionToAccessThisPage: "You don't have permission to access this page",
    TransferBalance: "Transfer Balance",

    // Transfer Balance Form
    FromSourceCard: "From",
    ToDestinationCard: "To",
    EnterCardSerial: "Enter card serial",
    GetInfo: "Get Info",
    FromSourceCardInfo: "From/Source Card Info",
    ToDestinationCardInfo: "To/Destination Card Info",
    Issued: "Issued",
    Blacklisted: "Blacklisted",
    Expired: "Expired",
    CurrentBalance: "Current Balance",
    BlacklistSourceCard: "Blacklist Source Card",
    Note: "Note",
    BlacklistFullTransferNote: "If blacklist is chosen, the full source/from card amount has to be transferred",
    BlacklistNote: "Blacklist note (optional)",
    TransferAmount: "Amount",
    UseAllBalance: "Transfer Full Balance",
    EnterAmount: "Enter amount",
    Transfer: "Transfer",
    PleaseEnterCardSerial: "Please enter card serial",
    ModeBalanceTransfer: "Balance Transfer",
    ModeCardReplacement: "Card Replacement",
    ModeBalanceTransferHint: "Only the amount entered moves. Any fare product stays on the source card.",
    ModeReplacementHint: "The full balance moves, the source card is blacklisted, and any active or pending fare product moves to the destination card.",
    CardOwner: "Card Owner",
    NotLinkedToAnyUser: "Not linked to any user",
    FareProduct: "Fare Product",
    NoFareProduct: "No fare product",
    ActivePendingLabel: "Active/Pending",
    GuardOrgMismatch: "Both cards must belong to the same issuing organisation.",
    GuardBothOwned: "These cards belong to two different passengers. Transfer is not allowed.",
    GuardReplacementDestNoOwner: "The destination card is not linked to a user. Ask the passenger to unlink the old card and link the new one in the mobile app, then retry.",
    GuardReplacementProductDestNoOwner: "The source card holds a fare product, so the destination card must be linked to a user to receive it.",
    GuardReplacementDestHasProduct: "The destination card already holds a fare product. A card cannot hold more than one.",
    GuardBalanceSourceProductNoOwner: "This card holds a fare product but is not linked to any user. Fix its ownership first.",
    GuardBalanceFullAmountWarning: "Moving the entire balance would leave the fare product on an empty card. Either use Card Replacement, or transfer a smaller amount.",
    TransferEligibility: "Transfer Fare Media Eligibility",
    TransferEligibilityWarning: "Any existing eligibility records on the destination card that overlap with the source card will be permanently overwritten.",
    AlreadyHasActiveInstance: "Already Active/Pending",
    AlreadyHasAnyActiveFareProduct: "Card already has an active or pending fare product",
    MissingRequiredDocuments: "Missing Required Documents",
    YourCurrentBalance: "Your Current Balance",
    BalanceAfterPurchase: "Balance After Purchase",
    AssignedRoutes: "Assigned Routes",
    BuyFareProductLogicHelp: 'These Fare Products are available for your Passenger Group.\n\n• Assigned Routes: Shows all routes you can ride on, combined from multiple assignments.\n• Assignment Validity: Shows the earliest start date and latest end date among your active assignments.\n\nNote: When using your card on the bus, the system will strictly enforce the exact valid dates for each specific route.',
    CancelledAt: "Cancelled At",
    CardInfoRetrievedSuccessfully: "Card info retrieved successfully",
    CardDoesNotExist: "Card does not exist",
    FailedToGetCardInfo: "Failed to get card info",
    PleaseEnterBothCardSerials: "Please enter both card serials",
    PleaseGetCardInfoFirst: "Please get card info first",
    PleaseEnterAmount: "Please enter amount or select use all balance",
    BlacklistRequiresFullTransfer: "If blacklist is chosen, the full source card amount has to be transferred",
    TransferSuccessful: "Transfer successful",
    TransferFailed: "Transfer failed",
    CardBlacklistedTransferError: "This card is blacklisted and can't be used in transfer balance transaction",
    DiscountBandAssignment: "Product & Promo Assignments",
    AddNewDiscountBandAssignment: "Add Discount Band Assignment",
    UpdateDiscountBandAssignment: "Update Discount Band Assignment",
    DiscountBandAssignmentInfo: "Discount Band Assignment Info",
    SearchDiscountBandAssignmentPlaceholder: "Search by Discount Band Name, Code or Passengers Group Name",
    AreYouSureDeleteDiscountBandAssignment: "Are you sure you want to delete this assignment?",
    DiscountBandAssignmentCreatedSuccessfully: "Discount Band Assignment Created Successfully",
    DiscountBandAssignmentUpdatedSuccessfully: "Discount Band Assignment Updated Successfully",
    Priority: "Priority",
    BandDateValidity: "Band Date Validity",
    TimeWindow: "Time Window",
    Value: "Value",
    BandDetails: "Fare Product Details",
    DateWindow: "Date Window",
    FixedAmount: "Fixed Amount",
    Open: "Open",
    TotalFareMediaInGroup: "Total Fare Media In Group",
    TotalUsersInGroup: "Total Users In Group",
    UniqueFareMediaWithOffer: "Count of fare media Purchasing this Offer",
    PurchasedOffersByGroup: "Total Purchased Offers",
    Analysis: "Analysis",
    ViewPriorityReference: "View Priority Reference",
    HidePriorityReference: "Hide Priority Reference",
    NoPriorityAssignmentsFound: "No other assignments found for this band.",
    Actions: "Actions",
    PriorityHint: "Used as a tiebreaker when multiple assignments apply the same discount to a trip.\n\nThe assignment with the lowest priority number wins.\n\nExample: Priority 10 beats Priority 100.\n\nDefault value is 100.",
    CurrentRecord: "Current",
    Active: "Active",
    Pending: "Pending",
    Cancelled: "Cancelled",
    DiscountBandsCount: "Discount Bands Count",
    FareProductFieldsIncompleteWarn: "Required for Fare Product Offer.",
    PleaseSelectOrgAndDate: "Please select an organisation and from date.",
    AssignmentLinkedToInactiveBand: "Warning: The parent Discount Band is INACTIVE. This assignment will not work!",
    BandDateCascadeWarning: "Note: If you shrink the validity dates, the system will shrink related Assignments to match. However, if any Assignment falls completely outside the new dates, the update will be blocked.",
    ExportingPleaseWait: "Exporting data... this may take a moment",
    ExportFailed: "Failed to export data. Please try again.",
    obcTime: "OBC Time",
    obcTimeFrom: "OBC Time From",
    obcTimeTo: "OBC Time To",
    discountBandAssignments: "Discount Band Assignments",
    discountApplied: "Discount Applied",
    createdAtFromDate: "Created At From Date",
    createdAtToDate: "Created At To Date",
    obcFromDate: "OBC From Date",
    obcToDate: "OBC To Date",
    BuyPass: "Buy Fare Product",
    SelectPass: "Select Fare Product",
    NoEligiblePasses: "No eligible fare products available",
    Buy: "Buy",
    // Restored missing keys
    Zoning: 'Zoning',
    confirmdeleteMessage: 'Are you sure you want to delete selected',
    createdBy: 'Created By',
    updatedBy: 'Updated By',
    Status: 'Status',
    NoAccess: 'No Access',
    FullAccess: 'Full Control',
    ReadOnly: 'Read Only',
    superadmin: 'Super Admin',
    amount: 'Amount',
    fromdate: 'From Date',
    todate: 'To Date',
    noorganization: 'No Organizations',
    vehicletype: 'Vehicle Type',
    vehicleclass: 'Vehicle Class',
    Routes: "Routes",
    SearchByName: "Search By Name , Code",
    Show: "Show : ",
    Login: " Login ",
    Logout: " Logout",
    ArabicName: "Arabic Name",
    EnglishName: "English Name",
    Organization: "Organization ",
    Groups: " Groups",
    Code: " Code",
    Username: "User Name",
    Password: "Password",
    RouteInfo: "Route Information",
    Axes: "Axes List",
    Cash: "Cash",
    Reset: "Reset",
    Card: "Card",
    Stops: "Stops",
    Save: "Save",
    Edit: "Edit",
    Stop: "Stop",
    PageNotFound: "Page Not Found ",
    Back: "Back",
    Filter: "Filter",
    Apply: "Apply",
    Delete: "Delete",
    Name: "Name",
    Cancel: "Cancel",
    Add: "Add",
    discountAmount: 'Discount Amount',
    yes: "Yes",
    no: "No",
    Update: "Edit",
    ConfirmPassword: "Confirm Password",
    StartDate: "Start Date",
    EndDate: "End Date",
    vat: "Vat",
    paidAmount: 'Paid Amount',
    Balance: "Balance",
    priority: "Priority",
    validity: "Validity",
    Type: "Type",
    Route: "Route",
    Group: "Group",
    DiscountBandAssignmentsCount: "Discount Band Assignments Count",
    createdAt: "Created At (Server Time)",
    AvailableRoutes: "Available Routes",
    SelectedRoutes: "Selected Routes",
    FareProducts: 'Fare Products',
    Promotions: 'Promotions',
    AddNewPromotion: 'Add New Promotion',
    AddNewFareProduct: 'Add New Fare Product',
    AreYouSureDeletePromotion: 'Are you sure you want to delete this promotion?',
    AreYouSureDeleteFareProduct: 'Are you sure you want to delete this fare product?',
    PromotionInfo: 'Promotion Information',
    FareProductInfo: 'Fare Product Information',
    EditPromotion: 'Edit Promotion',
    EditFareProduct: 'Edit Fare Product',
    PromotionCreatedSuccessfully: 'Promotion Created Successfully',
    FareProductCreatedSuccessfully: 'Fare Product Created Successfully',
    PromotionUpdatedSuccessfully: 'Promotion Updated Successfully',
    FareProductUpdatedSuccessfully: 'Fare Product Updated Successfully',
    FareProductEmptyFieldsWarningTitle: 'Missing Fare Product Fields',
    FareProductEmptyFieldsWarningMsg: 'By leaving Purchase Price, Contract Duration (Days), Max Spend Amount, and Max Trips empty (or any of them), this record will be saved as a Promotion — not a Fare Product — and any selected Documents will be cleared.',
    ContinueAsPromotion: 'Continue as Promotion',
    GoBackFillFields: 'Go Back & Fill Fields',
    ConvertToFareProduct: 'Convert to Fare Product',
    ConvertToPromotion: 'Convert to Promotion',
    ConvertToPromotionWarningTitle: 'Convert Fare Product to Promotion',
    ConvertToPromotionWarningMsg: 'Note: By converting this fare product to a promotion, the following values will be reset or removed: Purchase Price, Contract Duration (Days), Max Spend Amount, Max Trips, Activation Trigger, Requires Documents, and all selected documents.',
    ContinueConvertToPromotion: 'Continue & Convert',
    GoBackKeepFareProduct: 'Go Back',

    // ── Configuration → Fare Media reference data ──────────────────────────
    // Sub-systems: FareMediaIssuers, FareMediaIssuersOrganisations,
    // FareMediaTypes (master_configuration, category 2).
    FareMediaIssuers: 'Fare Media Issuers',
    FareMediaIssuer: 'Fare Media Issuer',
    AddNewFareMediaIssuer: 'Add Fare Media Issuer',
    EditFareMediaIssuer: 'Edit Fare Media Issuer',
    FareMediaIssuerInfo: 'Fare Media Issuer Info',
    SearchFareMediaIssuerPlaceholder: 'Search by name, phone, email or address...',
    AreYouSureDeleteFareMediaIssuer: 'Are you sure you want to delete this fare media issuer?',
    FareMediaIssuerCreatedSuccessfully: 'Fare media issuer created successfully',
    FareMediaIssuerUpdatedSuccessfully: 'Fare media issuer updated successfully',

    FareMediaIssuerOrganizations: 'Issuer Organizations',
    AddNewFareMediaIssuerOrganization: 'Assign Issuer to Organization',
    EditFareMediaIssuerOrganization: 'Edit Issuer Assignment',
    FareMediaIssuerOrganizationInfo: 'Issuer Assignment Info',
    SearchFareMediaIssuerOrganizationPlaceholder: 'Search by issuer or organization name...',
    AreYouSureDeleteFareMediaIssuerOrganization: 'Are you sure you want to delete this issuer assignment?',
    FareMediaIssuerOrganizationCreatedSuccessfully: 'Issuer assigned to the organization successfully',
    FareMediaIssuerOrganizationUpdatedSuccessfully: 'Issuer assignment updated successfully',

    FareMediaTypes: 'Fare Media Types',
    AddNewFareMediaType: 'Add Fare Media Type',
    EditFareMediaType: 'Edit Fare Media Type',
    FareMediaTypeInfo: 'Fare Media Type Info',
    SearchFareMediaTypePlaceholder: 'Search fare media types...',
    AreYouSureDeleteFareMediaType: 'Are you sure you want to delete this fare media type?',
    FareMediaTypeCreatedSuccessfully: 'Fare media type created successfully',
    FareMediaTypeUpdatedSuccessfully: 'Fare media type updated successfully',

    // shared field labels
    Address: 'Address',
    AssignedOrganisations: 'Assigned Organizations',
    IssuedFareMedia: 'Issued Fare Media',
    IsOld: 'Legacy',
    IsTest: 'Test',
    IsOldHint: 'Marks a superseded card type. Kept so existing cards still resolve, but it should not be used for new batches.',
    IsTestHint: 'Marks a type used for testing only. Test cards are excluded from operational reporting.',

    // organizations: extra details (Express API)
    orgAdditionalDetails: 'Additional Details',
    orgAdditionalDetailsIntro:
      'The organization was created. Set its additional details below, or skip and complete them later from the Edit screen.',
    orgSkipForNow: 'Skip for now',
    orgExtraDetailsSaved: 'Organization additional details saved successfully',
    orgExtraDetailsSaveFailed:
      'The organization was updated, but saving the additional details failed',
    orgExtraDetailsLoadFailed:
      'Could not load the additional details. You can still edit the names and status.',
    orgCode: 'Organization Code',
    orgShowHint: 'Show hint',
    orgKind: 'Organization Type',
    orgKindHint: 'An organization is either My Company or a PTO, never both.',
    orgKindMyCompany: 'My Company',
    orgKindPto: 'PTO',
    orgIsSuper: 'Super Organization',
    orgMaxDevices: 'Max Devices Allowed',
    orgCurrentDevices: 'Current Devices',
    orgChargingBackendUrl: 'Charging Backend Base URL',
    orgThresholdValue: 'Threshold Value',
    orgThresholdHint:
      'Important: if a card balance falls below this value, the card is blacklisted until it is charged again. Applies to both online and offline cards.',
    orgServiceDayCutoff: 'Service Day Cutoff (UTC)',
    orgServiceDayCutoffHint: 'This is a UTC time, not local time.',
    orgCurrency: 'Currency',
    orgInvalidMaxDevices: 'Enter a whole number between 0 and 99999999',
    orgInvalidChargingUrl: 'Enter a valid http(s) URL (max 255 characters)',
    orgInvalidThreshold: 'Enter a valid number',
    orgInvalidCutoff: 'Enter a valid UTC time (HH:mm:ss)',
    orgInvalidCurrency: 'Enter a 3-letter currency code, e.g. EGP',
  },

};
